import {uniqueFilter} from './unique/uniqueFilter';

let appModule = angular.module('deliveryCreate.app');
appModule.filter('unique', uniqueFilter);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/filters/bootstrap.ts
 **/